import React, { useState, useEffect } from 'react';

import { CambiarClave } from '../../comun/modalCambiarClave';
import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";

 
import useTable from "../../useTable"
import { ActualizarUsuarioFact } from './modalActualizarUsuarioFact';
/* import { ActualizarUsuarioPP } from './modalActualizarUsuarioFact'; */

const headCells = [
    { id: 'codigo', label: 'CODIGO', width: '10px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'usuario', label: 'USUARIO', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'nombreape', label: 'NOMBRES', width: '300px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'accion', label: 'OPCIONES', width: '120px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
]

function TablaUsuarioFacturacion() {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [idUsuarioH, setIdUsuarioH] = useState(0);
    const [contar, setContar] = useState(0);
    const [contar1, setContar1] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [contar5, setContar5] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [usuarioH, setUsuarioH] = useState();
    const [persona, setPersona] = useState();
    const [organizacion, setOrganizacion] = useState();
    const [configCome, setConfigCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [pagow, setPagow] = useState();
    const [retencion, setRetencion] = useState();
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [permiso, setPermiso] = useState();

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../../src/modulos/datos');

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idusuario.includes(target.value)
                            || x.login.toLowerCase().includes(target.value.toLowerCase())
                            || (x.personaByPersona.nombres + ' ' + x.personaByPersona.apellidos).toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }


    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setPermiso(JSON.parse(localStorage.getItem('permisos'))[0].accusuariocome);
        setFechaSistema(obj[0].fechasistema);
        setIdUsuario(obj[0].idusuario);
        setEspiritu(obj[0].espiritu);
        seleccionarUsuarios();
        /*seleccionarStatus();
        seleccionarConfiguracion();*/


    }, []);

    useEffect(() => {

        if (contar === 0) {
            if (errorUsu) {
                setActivate(false);
                let obj = JSON.parse(JSON.stringify(errorUsu));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }

        if (contar === 0) {
            if (errorU) {
                setActivate(false);
                let obj = JSON.parse(JSON.stringify(errorU));
                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }

    });


    const agregarUsuario = () => {
        setOperacion(1);
        setUsuarioH();
        setUsuariow();
        setPersona();
        setDeshabilitado(false);
        setMostrar5(true);
    };

    const cambiarClave = () => {
        setMostrar2(true);
    };

    const cerrarModalActualizar = () => {

        setUsuarioH();
        setUsuariow();
        setPersona();
        setMostrar5(false);
        renderizar();
        //window.location.href = '/comercio'
    }

    const validarActuUsuario = () => {
        /*setDesde(2);*/
        //setIdEmpresa(txtId);
        if (operacion === 4) {
            setUsuarioH();
            setMostrar5(false);
            return;
        }
        if (operacion === 1) {
            setIdUsuarioH(0);
        }
        /*alert(JSON.stringify(come));
        alert(JSON.stringify(repre));
        alert(JSON.stringify(actixcome));*/

        /*setComerAct(come);
        setRepreAct(repre);
        setActixComeAct(actixcome);
        setOperaPer(operacionPer);
        setMostrar4(true);*/
        setUsuarioH();
        setUsuariow();
        setPersona();
        setMostrar5(false);
        window.location.href = '/usuariosVehiculos';
    }

    const handleCloseMensa = () => {
        setMostrar(false);
        if (contar3 > 0) {
            window.location.href = '/comercio'
            //renderizar();
        }
    }

    const handleCloseClave = () => {
        setMostrar2(false);
    }


    const renderizar = () => {
        seleccionarUsuarios();
    }

    const seleccionarUsuarios = () => {
        setContar4(0);
        setContar(0);
        setActivate(true);

    };

    const consultarUsuario = (id, index) => (event) => {
        event.preventDefault();
        setDeshabilitado(true);
        setOperacion(4);
        //setIdComercio(recordsAfterPagingAndSorting()[index].idefiscal);
        setIdUsuarioH(id);
        setContar(0);
        setContar1(0);
        setContar5(0);
        setActivate(true);

    };

    const editarUsuario = (id, index) => (event) => {
        event.preventDefault();
        setDeshabilitado(false);
        setOperacion(2);
        //setIdComercio(recordsAfterPagingAndSorting()[index].idefiscal);
        setIdUsuarioH(id);
        setContar(0);
        setContar1(0);
        setContar5(0);
        setActivate(true);

        //setMostrar5(true);
    };

    const eliminarUsuario = (id, index) => (event) => {
        event.preventDefault();
        if (idUsuario === id) {
            setTitulo("Error");
            setMsg("El Usuario no se puede eliminar porque esta logueado");
            setMostrar(true);
            return;
        }
        setDeshabilitado(true);
        setOperacion(3);
        //setIdComercio(recordsAfterPagingAndSorting()[index].idefiscal);
        setIdUsuarioH(id);
        setContar(0);
        setContar1(0);
        setContar5(0);
        setActivate(true);

        //setMostrar5(true);
    };


    return (
        <div className="card">
            <ActualizarUsuarioFact
                show={mostrar5} titulo={titulo1} mensaje={msg1}
                onHideCancela={cerrarModalActualizar}
                onHideAcepta={validarActuUsuario}
                usuario={usuarioH}
                datospersonales={persona}
                deshabilitado={deshabilitado ? deshabilitado : undefined}
                ingresa={0}
                declaweb={configCome ? configCome[0].declaweb.toString() : 'false'}
                idusuario={idUsuario}
                operacion={operacion}
            />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <CambiarClave
                show={mostrar2}
                onHide={handleCloseClave} />
            
            {/* /.card-header */}
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <input className="search-input form-control mr-sm-2" style={{ border: '1px solid #007bff' }} type="search" placeholder="Buscar" onChange={handleSearch} aria-label="Search" />
                                    </div>
                                    <div className="col-md-5"></div>
                                    <div /* style={{ padding: '10px' }} */ className="col-md-2">
                                        <button disabled={permiso && permiso.substring(1, 2) !== "1" && permiso.substring(2, 3) !== "1"} onClick={cambiarClave} style={{ marginBottom: "10px" }} className="btn col-md-12 btn-outline-primary"><i className="fas fa-key"> Cambiar Clave</i> </button>
                                    </div>
                                    <div /* style={{ padding: '10px' }} */ className="col-md-2">
                                        <button disabled={permiso && permiso.substring(1, 2) !== "1"} onClick={agregarUsuario} style={{ marginBottom: "10px" }} className="btn col-md-12 btn-outline-primary"><i className="fa fa-user-plus"> Agregar Usuario</i> </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idcomercio} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "10px" }}>{item.idusuario}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.login}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.personaByPersona.nombres + ' ' + item.personaByPersona.apellidos}</td>
                                                    <td align="center" style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "180px", padding: 0 }}>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(0, 1) !== "1" ? 'none' : '' }} onClick={consultarUsuario(item.idusuario, index)} className="btn btn-outline-info"><i className="fas fa-search"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(2, 3) !== "1" ? 'none' : '' }} onClick={editarUsuario(item.idusuario, index)} className="btn  btn-outline-success"><i className="fa fa-edit"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(3, 4) !== "1" ? 'none' : '' }} onClick={eliminarUsuario(item.idusuario, index)} className="btn  btn-outline-danger"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <TblPagination />

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">



                </div>
            </div>

        </div>

    );

}

export default TablaUsuarioFacturacion;
